import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, ReplaySubject } from 'rxjs';
import { MyTranslateService } from 'src/app/modules/my-translate/my-translate.service';
import { getAllSidebar, UserData } from 'src/app/services/api/user.service';
import { LoggerService } from 'src/app/services/logging/logger.service';
import { UserAuthService } from 'src/app/services/user/user-auth.service';

const HOME_ROUTE = "/";

@Injectable()
export class MainAppMenuService {

  menu: any[] | null = null;
  private menuSubject = new ReplaySubject<any[] | null>();
  private getAllSidebarPromise: Promise<any> | null = null;

  private userData : UserData | null = null; 
  private isLogin = false;
  private defaultRoute?: string;
  private defaultQueryParams?: Params;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private user: UserAuthService,
    private translate: MyTranslateService,
    private logger: LoggerService
  ) {
    this.user.getUserDataSubject().subscribe(res => {
      
      this.userData = res;

      if (res === null) {
        this.menu = null;
        this.menuSubject.next(null);
        this.isLogin = false;

        console.warn("USER CHECK DISABLE")
        this.getMenu()
      } else {
        this.isLogin = true;
        this.getMenu();
      }
    })
  }

  private async getMenu(){ 
    if (this.getAllSidebarPromise) return this.getAllSidebarPromise;
    this.getAllSidebarPromise = getAllSidebar();
    this.getAllSidebarPromise.then(res => {
      this.menu = res?.data;
      this.menuSubject.next(this.menu);
    }).finally(()=> {
      this.getAllSidebarPromise = null;
    })
    return this.getAllSidebarPromise;
  }

  async canAccessMenu(id: string | number){
    this.logger.warn("CanAccessMenu temporarily disabled");
    /*
    if (this.menu === null && this.isLogin) {
      await this.getMenu();
    }
    if (this.menu === null) return;
    const found = this.menu.find(el => el.id_mst_sidebar == id);
    if (found) {
      return;
    }
    this.toastr.error(this.translate.instant('you_cannot_access_this_page','Anda tidak dapat mengakses halaman ini'));
    //If can't access, navigate to set default route, or home
    this.router.navigate([this.defaultRoute ? this.defaultRoute : HOME_ROUTE]);
    */
  }

  setDefaultRoute(route: string, queryParams: Params = {}) {
    this.defaultRoute = route;
    this.defaultQueryParams = queryParams;
  }

  getDefaultRoute(){
    return this.defaultRoute;
  }

  getDefaultQueryParams(){
    return this.defaultQueryParams;
  }

  getMainAppMenuObservable(){
    return this.menuSubject as Observable<any[] | null>;
  }
}
